import React from 'react';

import { daysLeft } from './PaymentMethodDaysLeft.scss';

type SVGProps = React.SVGAttributes<SVGElement>;

interface Props {
  message: React.ReactNode;
  icon?: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps>>;
}

const PaymentMethodDaysLeft = ({ message, icon }: Props) => (
  <span className={daysLeft}>
    {icon}
    {message}
  </span>
);
export default PaymentMethodDaysLeft;
